
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyC96ZiBlcJaV4kA9_Yw2vzexeGe4GDvceA",
  authDomain: "ehipassiko-buddhist-cent-1532c.firebaseapp.com",
  projectId: "ehipassiko-buddhist-cent-1532c",
  storageBucket: "ehipassiko-buddhist-cent-1532c.firebasestorage.app",
  messagingSenderId: "39641508274",
  appId: "1:39641508274:web:3c94d17278c30c62249cab"
};
  

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export


